import { environment } from '../../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CurrencyService {

    private currencySubject: BehaviorSubject<any>;
    private currencyAllSubject: BehaviorSubject<any>;
    public currencySymbol: Observable<any>;
    constructor(
        private http: HttpClient
    ) {
        this.currencySubject = new BehaviorSubject<any>("");
        this.currencyAllSubject = new BehaviorSubject<any>([]);
        this.currencySymbol = this.currencySubject.asObservable();
    }

    public get currencySymbolValue(): any {
        return this.currencySubject.value;
    }
    public get currencySymbolAllValue(): any {
        return this.currencyAllSubject.value;
    }

    async getBaseCurrency() {
        const currencySymbol = this.currencySubject?.getValue();
        if (currencySymbol != "") {
            return currencySymbol;
        } else {
            await this.http.get<any>(`${environment.appOrgUrl}OrganizationCurrency/GetAllCurrencies`)
                .toPromise()
                .then(res => {
                    const allCurrency = res ?? [];
                    const baseCurrency = allCurrency?.find(currency => currency.isBaseCurrency == true) ?? null;
                    const baseCurrencySymbol = baseCurrency?.symbol ? baseCurrency.symbol.trim() : "";
                    this.currencySubject.next(baseCurrencySymbol);
                    this.currencyAllSubject.next(allCurrency);
                });

            return this.currencySubject?.getValue();
        }
    }


}
